import React from "react";
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import { StaticImage } from "gatsby-plugin-image";
import { useI18nL10nContext } from "gatsby-plugin-i18n-l10n";
import { Box } from "@mui/material";

export default function CtaButton(props: any) {
    const languageContext = useI18nL10nContext();
    //console.log("languageContext: ", languageContext)
    return (
        <>
            {props.windowWidth > 768 ?
                <Box className="menuCta" >
                    <OutboundLink href="http://andmar.cloud" >
                        {languageContext.locale?.includes("en") ?
                            <StaticImage style={{ width: "275px", maxHeight:"48px" }} src="../../images/menuCtaButton.png" alt="" /> :
                            <StaticImage style={{ width: "275px", maxHeight:"48px" }} src="../../images/menuCtaButtonFR.png" alt="" />
                        }
                    </OutboundLink>
                </Box>
                :
                <Box className="menuCtaRound" >
                    <OutboundLink href="http://andmar.cloud" >
                        <StaticImage style={{ maxHeight:"48px", maxWidth:"48px" }} src="../../images/menuCtaButtonRound.png" alt="" backgroundColor="transparent"/>
                    </OutboundLink>
                </Box>
            }
        </>
    )
}